var _circle, _path, _path2, _path3, _circle2, _circle3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShared(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bold",
    enableBackground: "new 0 0 24 24",
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.25 23h-6.5c-.414 0-.75-.336-.75-.75v-1.5c0-1.517 1.233-2.75 2.75-2.75h2.5c1.517 0 2.75 1.233 2.75 2.75v1.5c0 .414-.336.75-.75.75z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.25 17h-1.33c.98.95 1.58 2.28 1.58 3.75v.25h1.75c.41 0 .75-.34.75-.75v-.5c0-1.52-1.23-2.75-2.75-2.75z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m5.75 17c-1.52 0-2.75 1.23-2.75 2.75v.5c0 .41.34.75.75.75h1.75v-.25c0-1.47.6-2.8 1.58-3.75z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 14,
    r: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m2.551 16.277c.253-.231.525-.441.822-.615-.234-.508-.373-1.067-.373-1.662 0-2.206 1.794-4 4-4 1.256 0 2.365.594 3.099 1.503.568-.311 1.209-.503 1.901-.503s1.333.192 1.901.503c.734-.909 1.843-1.503 3.099-1.503 2.206 0 4 1.794 4 4 0 .595-.139 1.154-.373 1.662.191.112.372.238.545.374 1.698-1.08 2.828-2.962 2.828-5.103 0-3.066-2.307-5.625-5.327-6.006-1.312-2.399-3.884-3.927-6.673-3.927-3.545 0-6.62 2.465-7.397 5.829-2.584.272-4.603 2.442-4.603 5.071 0 1.869 1.032 3.489 2.551 4.377z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShared);
export default __webpack_public_path__ + "static/media/shared.dab3fe36b16f2728f39134d2fce977e3.svg";
export { ForwardRef as ReactComponent };